// Tarifs : mêmes offres qu'avant (API publique, repli si elle ne répond pas,
// bascule mensuel / annuel). Les abonnements se souscrivent dans l'app.
import React, { useEffect, useState } from "react";
import { getSubscriptionTypesPublic } from "../../services/authService";
import { IconeCoche } from "../../site/Icones";

const REPLI = {
	starter: ["Entraînements illimités", "Synchronisation cloud", "Modèles personnalisés", "Dashboard mobile", "Gym'Coach : ta séance série par série"],
	pro: [
		"Entraînements illimités",
		"Synchronisation cloud",
		"Modèles personnalisés",
		"Dashboard mobile",
		"Planification avancée",
		"Dashboard Coach web",
		"Jusqu'à 100 élèves",
		"Gym'Coach : ta séance série par série",
	],
};

const GRATUIT = ["Séances illimitées", "Bibliothèque d'exercices", "Minuteur de repos", "Suivi du poids de corps", "Partage avec tes partenaires"];

const formaterPrix = (p) => String(p).replace(".", ",");

function Carte({ nom, prix, unite, description, points, vedette = false }) {
	return (
		<div className={`gs-carte gs-tarif${vedette ? " gs-tarif--vedette" : ""}`}>
			{vedette && <span className="gs-tarif-drapeau">Le plus populaire</span>}
			<div className="gs-tarif-nom">{nom}</div>
			<div className="gs-tarif-prix">
				<strong>{prix} €</strong>
				<span>{unite}</span>
			</div>
			<p className="gs-tarif-desc">{description}</p>
			<ul>
				{points.map((p) => (
					<li key={p}>
						<IconeCoche taille={16} />
						<span>{p}</span>
					</li>
				))}
			</ul>
		</div>
	);
}

export default function Tarifs() {
	const [periode, setPeriode] = useState("mois");
	const [offres, setOffres] = useState(null);

	useEffect(() => {
		let annule = false;
		getSubscriptionTypesPublic().then((resultat) => {
			if (!annule && resultat?.success) setOffres(resultat.types);
		});
		return () => {
			annule = true;
		};
	}, []);

	// Le palier technique, pas le libellé : « GymNote+ » ne contient pas « starter ».
	const duPalier = (palier) => offres?.filter((o) => o.tier === palier && o.prix > 0) || [];
	const choisir = (palier, prixRepli) => {
		const liste = duPalier(palier);
		const mensuelle = liste.find((o) => o.dureeMois === 1);
		const annuelle = liste.find((o) => o.dureeMois === 12);
		const offre = periode === "an" && annuelle ? annuelle : mensuelle;
		const annuel = offre ? offre.dureeMois === 12 : periode === "an";
		const prix = offre?.prix ?? prixRepli[periode];
		const points = (mensuelle || annuelle)?.fonctionnalites?.map((f) => f.libelle) || REPLI[palier];
		return { prix, annuel, points };
	};

	const plus = choisir("starter", { mois: 9.99, an: 99.99 });
	const pro = choisir("pro", { mois: 24.99, an: 249.99 });
	const parMois = (prix) => formaterPrix((prix / 12).toFixed(2));

	return (
		<section className="gs-section" id="tarifs" aria-labelledby="gs-tarifs-titre">
			<div className="gs-conteneur">
				<div className="gs-tete-section gs-tete-section--centre">
					<span className="gs-surtitre">Tarifs</span>
					<h2 id="gs-tarifs-titre" className="gs-h2">
						Commence gratuitement.
					</h2>
					<p className="gs-texte gs-texte--centre">Passe au niveau supérieur quand tu es prêt. Sans engagement.</p>
				</div>

				<div style={{ display: "flex", justifyContent: "center" }}>
					<div className="gs-periode" role="group" aria-label="Période de facturation">
						<button type="button" aria-pressed={periode === "mois"} onClick={() => setPeriode("mois")}>
							Mensuel
						</button>
						<button type="button" aria-pressed={periode === "an"} onClick={() => setPeriode("an")}>
							Annuel <span className="gs-economie">−17 %</span>
						</button>
					</div>
				</div>

				<div className="gs-tarifs">
					<Carte nom="Sportif" prix="0" unite="pour toujours" description="Pour démarrer et suivre tes séances." points={GRATUIT} />
					<Carte
						vedette
						nom="GymNote+"
						prix={formaterPrix(plus.prix)}
						unite={plus.annuel ? "par an" : "par mois"}
						description={plus.annuel ? `Soit ${parMois(plus.prix)} € par mois.` : "Gym'Coach prépare chacune de tes séances, série par série."}
						points={plus.points}
					/>
					<Carte
						nom="GymNote Pro"
						prix={formaterPrix(pro.prix)}
						unite={pro.annuel ? "par an" : "par mois"}
						description={pro.annuel ? `Soit ${parMois(pro.prix)} € par mois.` : "Pour les coachs qui suivent leurs athlètes à l'échelle."}
						points={pro.points}
					/>
				</div>

				<p className="gs-tarifs-note">Les abonnements se souscrivent dans l'app, sur l'App Store ou Google Play.</p>
			</div>
		</section>
	);
}
